import { OKXWalletName } from './adapters/okx-adapter';

export const WALLET_POSITION_MAP: Record<string, number | undefined> = {
  'Continue with Google': 0,
  Petra: 200,
  [OKXWalletName]: 250,
  Backpack: 260,
  'Bitget Wallet': 300,
  'Continue with Apple': 500,
  'Pontem Wallet': 600,
  Nightly: 700,
  MSafe: 1200,
};
